import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Leonardo_Diffusion_XL_3d_UX_style_character_manager_at_work_si_1 (1)_upscayl_4x_realesrgan-x4plus-anime.png";
import Tilt from "react-parallax-tilt";

import { FaBehanceSquare, FaEnvelope, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { FaFacebook, FaInstagram, FaXTwitter } from "react-icons/fa6";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am a versatile professional with a passion for excelling in diverse fields, including graphic design, digital marketing, copywriting, social media management, photography, video editing, and photo manipulation. My work spans platforms like Upwork, Gig, and <i className="purple">Autoentrepreneur.tn</i>.
              <br /><br />
              In addition to my <i className="purple">technical expertise</i>, I’ve been actively developing <i className="purple">soft skills</i> such as public speaking, team building, creative thinking, problem-solving, leadership, and emotional intelligence, which complement my professional endeavors.
              <br />
              <br />
              Currently, I’m deeply engaged in both <i className="purple">entrepreneurship</i> and <i className="purple">freelancing</i>. I’m co-founding a startup called <a href="https://fahemni.tn" className="purple">Fahemni.tn</a> with <a href="https://azizbecha.com" className="purple">azizbecha.com</a> (our web developer) while contributing to <a href=" https://www.teol.com.tr" className="purple">TEOL</a> as an <i className="purple">English Teacher and Multilingual Marketing Specialist</i> in Turkey.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <a href="mailto:contact@raoufchatti.com" className="purple">connect</a> with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.behance.net/raoufchatti"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaBehanceSquare />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/raoufchatti/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedin />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/raoufchatti"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaXTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/raoufchatti"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://facebook.com/raoufchattii"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:contact@raoufchatti.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaEnvelope />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://api.whatsapp.com/send?phone=905379967762"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaWhatsapp />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
